export const REQUEST_PASSWORD_AJAX_SUCCESS = "REQUEST_PASSWORD_AJAX_SUCCESS";